import React, { useState } from 'react';
import styled from 'styled-components';

import ResponsiveNav from '../ResponsiveNav/ResponsiveNav';

export interface BurgerProps {
  open: boolean;
}

const StyledBurger = styled.div<BurgerProps>`
  width: 2rem;
  height: 2rem;
  position: fixed;
  top: 23px;
  right: 20px;
  z-index: 20;
  display: none;
  cursor: pointer;
  @media (max-width: 1150px) {
    display: flex;
    justify-content: space-around;
    flex-flow: column nowrap;
  }
  div {
    width: 2rem;
    height: 0.32rem;
    background-color: ${(props) =>
      props.open ? props.theme.colors.darkGray : props.theme.colors.purple};
    border-radius: 10px;
    transform-origin: 1px;
    transition: all 0.3s linear;
    &:nth-child(1) {
      transform: ${({ open }) => (open ? 'rotate(45deg)' : 'rotate(0)')};
    }
    &:nth-child(2) {
      transform: ${({ open }) => (open ? 'translateX(100%)' : 'translateX(0)')};
      opacity: ${({ open }) => (open ? 0 : 1)};
    }
    &:nth-child(3) {
      transform: ${({ open }) => (open ? 'rotate(-45deg)' : 'rotate(0)')};
    }
  }
`;

export default function Burger() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <StyledBurger open={open} onClick={() => setOpen(!open)}>
        <div />
        <div />
        <div />
      </StyledBurger>
      <ResponsiveNav open={open} />
    </>
  );
}
